const RELOAD_GUARD_KEY = "chunk-load-error-reloaded-at";
const RELOAD_GUARD_WINDOW_MS = 10_000;

const isChunkLoadError = (err: unknown): boolean => {
  if (!err) return false;
  const anyErr = err as { name?: string; message?: string; code?: string };
  const name = anyErr.name ?? "";
  const message = anyErr.message ?? "";
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Loading CSS chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};

const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? "0");
  if (Date.now() - last < RELOAD_GUARD_WINDOW_MS) {
    // Already reloaded recently — the new bundle is also failing.
    // Don't loop; let the error surface so we can see it.
    return;
  }
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
};

export const installChunkLoadErrorHandler = () => {
  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event.error) || isChunkLoadError(event)) {
      reloadOnce();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadOnce();
    }
  });
};
